import { Stack } from '@mui/material';

import { useGetAccessRequest } from '@apono/client-app-sdk';

import MessageQpAlert from '@common/ui/MessageQpAlert';
import useRequiredParams from '@common/hooks/use-required-params';
import { Flags } from '@common/utils/flags/feature-flags';
import { useFlagFixed } from '@common/utils/flags/use-flag-fixed';

import RequestTitle from '@MyRequests/components/RequestTitle';
import RequestContent from '@MyRequests/organisms/RequestContent';
import { RequestFooter } from '@MyRequests/organisms/RequestFooter';
import { Page } from '@common/ui/Page';

export default function RequestDetailsPage() {
  const { id } = useRequiredParams(['id']);

  const { data, isFetched, isFetching, error, refetch, dataUpdatedAt } = useGetAccessRequest(id, 10 * 1000);
  const { isEnabled: isMyAccessEnabled } = useFlagFixed(Flags.PORTAL_MY_ACCESS);

  return (
    <Page title={<RequestTitle {...{ requestId: id, isFetching, dataUpdatedAt }} onFetch={refetch} />}>
      <Stack direction="column" spacing={3} maxWidth="48rem">
        <MessageQpAlert />
        <RequestContent {...{ data, error, isFetched, isMyAccessEnabled }} />
        {data && <RequestFooter data={data} />}
      </Stack>
    </Page>
  );
}
